import { PlaceholderValue } from 'next/dist/shared/lib/get-img-props';

const FALLBACK_MEDIA_FEATURED_URL = process.env.NEXT_PUBLIC_FALLBACK_MEDIA_FEATURED_URL;
const IMAGE_CDN_URL = process.env.NEXT_PUBLIC_IMAGE_CDN_URL;

export type AssetUrlCdnPathType = {
  media?: MediaObjType | MediaCoverType;
  options?: AssetCdnOptionsType;
};

type AssetCdnOptionsType = {
  thumbnail?: boolean;
  cover?: boolean | 'cover-card';
};

export const mediaUrlCdn = ({ media, options }: AssetUrlCdnPathType) => {
  if (media?.resource_type === 'video') {
    return media?.image_url;
  }
  if (!media) {
    // fallback image
    return FALLBACK_MEDIA_FEATURED_URL as string;
  }

  // --------------------------------------
  // Media new version
  // --------------------------------------
  if (media?.image_url) {
    let transformation = '/';
    if (options?.thumbnail) {
      transformation = '/c_thumb,w_200,h_140,q_80/';
    }
    if (options?.cover && options.cover === true) {
      transformation = '/c_crop,g_auto,w_1728,h_560,q_70/';
    }
    if (options?.cover === 'cover-card') {
      transformation = '/w_640,h_320,q_70/';
    }
    const trimmed_path = media.image_url.replace(/^\//g, '');
    return `${IMAGE_CDN_URL}${transformation}${trimmed_path}`;
  }

  return '';
};

const FALLBACK_MEDIA_BLUR_DATA_URL = process.env.NEXT_PUBLIC_FALLBACK_MEDIA_BLUR_DATA_URL;

export type MediaBlurDataUrlType = {
  media?: MediaObjType | MediaCoverType;
};

export const mediaBlurDataUrl = ({ media }: MediaBlurDataUrlType): PlaceholderValue => {
  return (
    (media && `data:image/jpeg;base64,${media?.blur_data_url}`) || (FALLBACK_MEDIA_BLUR_DATA_URL as PlaceholderValue)
  );
};
